import React from 'react';
import * as R from 'ramda';
import Box from '@mui/material/Box';
import { indexReduce } from '@cd/utils';
//import styles from './css/ApplyPaymentToInvoices.scss';
import { FormCardRHF } from '@cd/rhf';
import { InputRHF } from '@cd/rhf';
import useDeleteInvoices from './../fetch/useDeleteInvoices';
import { FormGroupRHF } from '@cd/rhf';

const wrapSx = { marginTop: '16px', width: '420px', alignSelf: 'center' };

function getRecord({ selected }) {
	return indexReduce(
		(acc, val, index) =>
			R.mergeRight(acc, {
				[`id-${index}`]: val.id,
				[`date-${index}`]: val.v2
			}),
		{},
		selected
	);
}

const pluckIDs = R.compose(
	R.reduce(
		(acc, [key, val]) => (R.test(/id-/, key) ? R.append(val, acc) : acc),
		[]
	),
	R.tap(item => console.log('PLUCKED GUIDS:', item)),

	R.toPairs
);

const DeleteInvoice = ({ selected }) => {
	const record = getRecord({ selected });
	const { mutate } = useDeleteInvoices();
	const isSingle = selected.length === 1;

	return (
		<Box component="div" sx={wrapSx}>
			<FormCardRHF
				ignoreDirty
				onSubmit={data => {
					console.log('data', data);

					return mutate(pluckIDs(data));
				}}
				title="DELETE INVOICES"
				subtitle={`Delete ${isSingle ? 'single' : 'multiple'} invoice${
					isSingle ? '' : 's'
				}?`}
				okButtonTitle="DO IT"
				defaultValues={record}>
				{selected.map((v, i) => (
					<FormGroupRHF>
						<InputRHF name={`id-${i}`} label={`ID: ${i + 1}`} />
						<InputRHF name={`date-${i}`} label={`DATE: ${i + 1}`} />
					</FormGroupRHF>
				))}
			</FormCardRHF>
		</Box>
	);
};

export default DeleteInvoice;
